import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Divider,
  Input,
  Button,
  Tooltip,
  Select,
  Row,
  Col,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { StatusSwitch } from "../../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  selectFilterFunction,
  setTablePageSize,
} from "../../../Constants/Utilities";
import {
  rowLayout,
  colLayout,
  ConfigActions,
  StatusFilters,
  TablePageSizes,
  TablePages,
  EntityStatus,
} from "../../../Constants/Constants";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

class ListDeviceConfig extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListDeviceConfig props", props);
    this.state = {
      deviceConfigData: props.deviceConfigData,
      slectedDevice: props.selectedDevice,
    };
  }

  componentDidUpdate(prevProps) {
    const { modelData, deviceData, deviceConfigData } = this.props;
    if (
      prevProps.modelData !== modelData ||
      prevProps.deviceData !== deviceData ||
      prevProps.deviceConfigData !== deviceConfigData
    ) {
      this.setState({ modelData, deviceData, deviceConfigData });
    }
  }
  getColumns = () => [
    {
      title: "Configuration Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ConfigActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Config">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ConfigActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Config">
            <EditOutlined
              onClick={this.props.onActionClick(ConfigActions.edit, record)}
            />
          </Tooltip>
          {record.status === EntityStatus.INACTIVE && (
            <Tooltip title="Delete Config">
              <Popconfirm
                okText="Yes"
                cancelText="No"
                title="Are you sure want to Delete Config?"
                onConfirm={() => this.props.onConfigDelete(record)}
              >
                <DeleteOutlined />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { deviceConfigData } = this.props;
    if (!!text) {
      const filteredData = deviceConfigData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ deviceConfigData: filteredData });
      return;
    }
    this.setState({ deviceConfigData });
  };

  render() {
    const { deviceConfigData } = this.state;
    const {
      modelData,
      modelDataLoading,
      deviceData,
      deviceDataLoading,
      onActionClick,
      selectedDevice,
      deleteConfigLoading,
      selectedModel,
      onDeviceSelect,
      onModelSelect,
      deviceConfigDataLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <Row {...rowLayout}>
          <Col {...colLayout}>
            <div className="entity-selection-container">
              <span className="entity-label">Device Model:</span>
              <Select
                showSearch
                allowClear
                value={selectedModel}
                loading={modelDataLoading}
                disabled={modelDataLoading}
                onChange={onModelSelect}
                filterOption={selectFilterFunction}
                style={{ minWidth: "250px", maxWidth: "300px" }}
                placeholder={
                  modelDataLoading
                    ? "Loading Device Models..."
                    : "Select Device Model"
                }
              >
                {modelData?.map((item) => (
                  <Select.Option key={item.modelId} title={item.modelNumber}>
                    {item.modelNumber}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col {...colLayout}>
            <div className="entity-selection-container">
              <span className="entity-label">Device:</span>
              <Select
                showSearch
                allowClear
                labelInValue={true}
                loading={deviceDataLoading}
                disabled={!selectedModel || deviceDataLoading}
                filterOption={selectFilterFunction}
                onChange={onDeviceSelect}
                style={{ minWidth: "250px", maxWidth: "300px" }}
                placeholder={
                  !selectedModel
                    ? "Select Model to view Devices"
                    : deviceDataLoading
                    ? "Loading Devices..."
                    : "Select Device"
                }
              >
                {deviceData?.map((item) => (
                  <Select.Option
                    key={item.deviceUuid}
                    value={item.deviceUuid}
                    title={item.deviceId}
                  >
                    {item.deviceId}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Config Name"
              onChange={this.onSerchTextChange}
              disabled={!selectedDevice}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ConfigActions.add, null)}
            >
              Add Configuration
            </Button>
          </div>
        </div>
        {!selectedDevice ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Device to view configurations
            </div>
          </div>
        ) : (
          <Table
            bordered
            size="small"
            columns={this.getColumns()}
            className="entity-table"
            loading={
              deleteConfigLoading ||
              (deviceConfigDataLoading && {
                tip: "Fetching Configurations...",
              })
            }
            dataSource={deviceConfigData}
            pagination={{
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              defaultPageSize: getTablePagesize(TablePages.listDeviceConfig),
              pageSizeOptions: TablePageSizes,
              onChange: (_, pageSize) =>
                setTablePageSize(TablePages.listDeviceConfig, pageSize),
            }}
          />
        )}
      </div>
    );
  }
}

ListDeviceConfig.propTypes = {
  modelData: PropTypes.array,
  modelDataLoading: PropTypes.bool,
  deleteConfigLoading: PropTypes.bool,
  selectedModel: PropTypes.string,
  deviceData: PropTypes.array,
  deviceDataLoading: PropTypes.bool,
  selectedDevice: PropTypes.string,
  deviceConfigData: PropTypes.array,
  deviceConfigDataLoading: PropTypes.bool,
  onModelSelect: PropTypes.func,
  onDeviceSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListDeviceConfig;
